import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Offers } from '../../rest/types/Offer'
import { Sort } from '../Filters/useSortingFilters'
import { sortByHigherPrice, sortByLowerPrice } from '../../helpers/OfferHelpers'
import { selectors } from '../../redux'

const useFilteredOffers = ({
  offers,
  defaultSorts,
}: {
  offers: Offers
  defaultSorts: Array<string>
}): { filteredOffers: Offers } => {
  const sort = useSelector(selectors.filters.sort)

  const filteredOffers = useMemo(() => {
    const items = offers

    switch (sort) {
      case Sort.HigherPrice:
        items.sort(sortByHigherPrice)
        break
      case Sort.LowestPrice:
        items.sort(sortByLowerPrice)
        break
      case Sort.Feedback:
        items.sort(sortByLowerPrice)
        break
      default:
        items.sort((a, b) => {
          return defaultSorts.indexOf(a.id) - defaultSorts.indexOf(b.id)
        })
        break
    }

    return items
  }, [offers, sort, defaultSorts])

  return useMemo(
    () => ({
      filteredOffers,
    }),
    [filteredOffers]
  )
}

export default useFilteredOffers
